import { Controller } from "@hotwired/stimulus"

// Shows a small name label on hover / focus / tap and auto-hides it after a delay.
export default class extends Controller {
  static targets = ["label"]
  static values = { delay: { type: Number, default: 2500 } }

  show() {
    this.labelTarget.classList.remove("opacity-0")
    this.scheduleHide()
  }

  hide() {
    clearTimeout(this.timeout)
    this.labelTarget.classList.add("opacity-0")
  }

  scheduleHide() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.hide(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
